var map = {
	"./detail-bio/bio.register.ts": 656642,
	"./detail-clinical-result/clinicalResult.register.ts": 641862,
	"./detail-clinical/clinical.register.ts": 47613,
	"./detail-drug/drug.register.ts": 592584,
	"./detail-investment/investment.register.ts": 568765,
	"./detail-market/market.register.ts": 234191,
	"./detail-merger/merger.register.ts": 902305,
	"./detail-paper/paper.register.ts": 138713,
	"./detail-patent/patent.register.ts": 987984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17805;